export default __webpack_public_path__ + "static/media/H0006.1c622ca8.png";